export const THEME = {
    light: 'app-light-theme' as const,
    dark: 'app-dark-theme' as const,
} as const;

export type Theme = (typeof THEME)[keyof typeof THEME];
